import { render, staticRenderFns } from "./CompanyBalanceRecordsHistory.vue?vue&type=template&id=e5ce377e"
import script from "./CompanyBalanceRecordsHistory.vue?vue&type=script&lang=ts"
export * from "./CompanyBalanceRecordsHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports